export default "__VITE_ASSET__9bb38911__"